'use client'

import PropTypes from 'prop-types'
import { useRef } from 'react'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'
import MUIBox from '@mui/material/Box'
import styles from './NavigationSidebarItem.module.scss'
import { useUrlStore } from '@repo/store/useUrlStore'
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'
import { useMenuItemsStore } from '@repo/store/useMenuItemsStore'
import { Link } from 'react-router-dom'

export const NavigationSidebarItem = ({ icon, label, menuKey, clickable = false }) => {
  const ref = useRef(null)
  const { urlSegments } = useUrlStore()
  const { sidebarMode } = useGlobalSettingsStore()
  const { openMainNavigationMenu } = useMenuItemsStore()

  const handleClick = () => {
    if (!clickable) {
      openMenu()
    }
  }

  const openMenu = () => {
    const { offsetTop, offsetLeft, offsetWidth } = ref.current || {}
    openMainNavigationMenu({
      rootKey: menuKey,
      offsetTop: offsetTop - 5,
      offsetLeft: offsetLeft + 10,
      offsetWidth,
      showMenuHeading: true,
      rootMenuHeading: label,
      minMenuHeight: label === 'Support' ? 160 : 460,
      maxMenuHeight: label === 'Support' ? 200 : 680
    })
  }

  const Component = clickable ? Link : MUIBox

  return (
    <Component
      className={styles.navIcon}
      data-testid="NavigationSidebarItem"
      ref={ref}
      onClick={handleClick}
      onMouseOver={openMenu}
      to={`/${menuKey}`}
    >
      <MUIStack
        data-testid={`NavigationSidebarItem-${label.replace(/ /g, '')}`}
        alignItems="center"
        justifyContent="flex-start"
        direction="row"
        className={`${styles.icon} ${urlSegments[0] === menuKey ? styles.active : ''} ${sidebarMode === 'expanded' ? styles.expanded : ''}`}
      >
        {icon}
        {sidebarMode === 'expanded' ? (
          <MUITypography
            variant="body1"
            className="NavigationSidebarItemText"
            sx={{ color: 'white', mb: 0, pl: '20px', pointerEvents: 'none', userSelect: 'none' }}
          >
            {label}
          </MUITypography>
        ) : null}
      </MUIStack>
    </Component>
  )
}

NavigationSidebarItem.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  menuKey: PropTypes.string.isRequired,
  clickable: PropTypes.bool,
  menuItemId: PropTypes.number
}
